import type { TOC } from '@ember/component/template-only';
import type { SafeString } from '@ember/template';

import { DataPerformanceSummaryTrend } from 'webapp/enums/enums';

import trendIconName from 'webapp/helpers/trend-icon-name';
import CommonUiIcon from 'webapp/components/common/ui-icon';

interface DataPerformanceSummaryIndicatorComponentInterface {
	Args: {
		trend: DataPerformanceSummaryTrend;
		text: SafeString | '';
		size?: IconSize;
	};
}

const DataPerformanceSummaryIndicatorComponent: TOC<DataPerformanceSummaryIndicatorComponentInterface> =
	<template>
		<div class="performance-change-indicator {{@trend}} trend--{{@trend}}">
			<CommonUiIcon
				@name={{trendIconName @trend}}
				@size={{if @size @size "xl"}}
				@class="data-performance-summary-trend"
			/>
			<p>{{@text}}</p>
		</div>
	</template>;

export default DataPerformanceSummaryIndicatorComponent;
